const d3 = Object.assign(
  {}, 
  require("d3-selection"), 
  require("d3-scale"), 
  require("d3-scale-chromatic"),
  require("d3-shape"),
  require("d3-array")
);

function pie() {
  // Multiline Chart with option to add areas

  ////////////////////////////////
  // Default Settings
  ////////////////////////////////
  var margin = { left: 5, right: 5, top: 5, bottom: 5 }, // default margin
      transitionDuration = 500,
      color = d3.scaleOrdinal()
                .range(d3.schemeSet2),
      labels = false,
      labelFn = () => '',
      strokeColor = () => '#fff',
      labelColor = () => '#aaa';

  ////////////////////////////////
  // Plotting Function
  ////////////////////////////////
  function my(selection) {

    selection.each(function(d) {

      var width = 200 - margin.left - margin.right,
          height = 200 - margin.top - margin.bottom;

      var radius = Math.min(width, height) / 2;

      var svg = d3.select(this).select("svg")
        .attr(
          "viewBox",
          `0 0 ${width + margin.left + margin.right}
          ${ height + margin.top + margin.bottom}`
        );

      if (svg.empty()) {
        svg = d3.select(this)
          .append("svg")
            .attr("class", "svg-content-responsive")
            .attr("preserveAspectRatio", "none")
            .attr(
              "viewBox",
              `0 0 ${width + margin.left + margin.right}
              ${ height + margin.top + margin.bottom}`
            );
      }

      var g = svg.select("g")
        .attr(
          "transform", 
          `translate(${margin.left + width / 2},${margin.top + height / 2})`
        );

      if (g.empty()) {
        g = svg.append("g")
          .attr(
            "transform", 
            `translate(${margin.left + width / 2},${margin.top  + height / 2})`
          );
      }

      // Compute the position of each group on the pie:
      var pie = d3.pie()
        .value(function(d) {return d.value; })
        .sort(function(a, b) { return d3.ascending(a.key, b.key);} ) // This make sure that group order remains the same in the pie chart
      var data_ready = pie(
        Object.entries(d).map(d => { 
          return { key: d[0], value: d[1] } 
        })
      )

      // shape helper to build arcs:
      var arcGenerator = d3.arc()
        .innerRadius(0)
        .outerRadius(radius)

      // map to data
      var u = g.selectAll("path")
        .data(data_ready)
        .join(
          enter => enter.append("path")
            .attr('d', arcGenerator)
            .attr('fill', function(d){ return(color(d)) })
            .attr("stroke", function(d){ return(strokeColor(d)) })
            .style("stroke-width", "2px")
            .style("opacity", 1),
          update => update
            .attr('d', arcGenerator)
            .attr('fill', function(d){ return(color(d)) })
        )
        

      if (labels) {
        g.selectAll('text')
          .data(data_ready)
          .join(
            enter => enter.append('text')
              .text(function(d){ return labelFn(d) })
              .attr("transform", function(d) { 
                return "translate(" + arcGenerator.centroid(d) + ")";  
              })
              .style("text-anchor", "middle")
              .style("font-size", 17)
              .style("fill", d => labelColor(d)),
            update => update
              .text(function(d){ return labelFn(d) })
              .attr("transform", function(d) { 
                return "translate(" + arcGenerator.centroid(d) + ")";  
              })
              .style("text-anchor", "middle")
              .style("fill", d => labelColor(d))
          )
      }

    })

  }

  ////////////////////////////////
  // Chart Options
  ////////////////////////////////

  my.margin = function(value) {
    if (!arguments.length) return margin;
    margin = value;
    return my;
  };

  my.color = function(value) {
    if (!arguments.length) return color;
    color = value;
    return my;
  };

  my.strokeColor = function(value) {
    if (!arguments.length) return strokeColor;
    strokeColor = value;
    return my;
  };

  my.transitionDuration = function(value) {
    if (!arguments.length) return transitionDuration;
    transitionDuration = value;
    return my;
  };

  my.labels = function(value) {
    if (!arguments.length) return labels;
    labels = value;
    return my;
  };

  my.labelFn = function(value) {
    if (!arguments.length) return labelFn;
    labelFn = value;
    return my;
  };

  my.labelColor = function(value) {
    if (!arguments.length) return labelColor;
    labelColor = value;
    return my;
  };

  return my;
}

export default pie;
